import { useState } from 'react';

import { trackAuthEvent } from '../../../services/analytics';

/** Logout confirmation modal state; `logout` is the auth context's logout. */
export function useLogoutConfirm(logout: () => Promise<void>) {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);

  const handleLogout = () => {
    trackAuthEvent('logout_requested', { source: 'profile' });
    setShowLogoutConfirm(true);
  };

  const handleConfirmLogout = async () => {
    if (logoutLoading) return;
    setLogoutLoading(true);
    try {
      trackAuthEvent('logout_confirmed');
      await logout();
    } finally {
      setLogoutLoading(false);
      setShowLogoutConfirm(false);
    }
  };

  const closeLogoutConfirm = () => setShowLogoutConfirm(false);

  return {
    showLogoutConfirm,
    logoutLoading,
    handleLogout,
    handleConfirmLogout,
    closeLogoutConfirm,
  };
}
